import styles from './AchievementProgress.module.css';
import darkKnightSilver from '../../../assets/coin_images/movies/dark_knight_coins/silver.png';
import darkKnightBronze from '../../../assets/coin_images/movies/dark_knight_coins/bronze.png';
import darkKnightGold from '../../../assets/coin_images/movies/dark_knight_coins/gold.png';
import darkKnightLegendary from '../../../assets/coin_images/movies/dark_knight_coins/legendary.png';

const defaultTiers = [
    {
        tier: 'Bronze',
        icon: '🥉',
        state: 'Earned',
        requirement: '5 / 8 Questions',
        description: 'Pass the verification.',
        detail: 'Questions Required: 5 correct answers',
        image: darkKnightBronze
    },
    {
        tier: 'Silver',
        icon: '🥈',
        state: 'Earned',
        requirement: '6–7 / 8 Questions',
        description: 'Strong movie knowledge.',
        detail: 'Questions Required: 6–7 correct answers',
        image: darkKnightSilver
    },
    {
        tier: 'Gold',
        icon: '🥇',
        state: 'Next Goal',
        requirement: 'Perfect Score',
        description: 'Perfect verification.',
        detail: 'Questions Required: 8 correct answers',
        image: darkKnightGold
    },
    {
        tier: 'Legendary',
        icon: '👑',
        state: 'Locked',
        requirement: 'Earn Gold again after the cooldown',
        description: 'Master the movie.',
        detail: 'Questions Required: two perfect verifications',
        image: darkKnightLegendary
    },
];

function AchievementCoin({ tier, poster, title }) {
    return (
        <div className={styles.coin} >
            <img src={poster} alt="" />
        </div>
    );
}

function ProgressConnector() {
    return <div className={styles.connector} aria-hidden="true"><span /></div>;
}

function AchievementTier({ tier, movie }) {
    const isLocked = tier.state === 'Locked';

    return (
        <article className={`${styles.tierCard} ${styles[`tier${tier.tier}`]}`} tabIndex="0">
            <AchievementCoin tier={tier.tier} poster={tier.image} title={movie.title} />
            <div className={styles.tierCopy}>
                <div className={styles.tierHeading}>
                    <h3>{tier.icon} {tier.tier}</h3>
                    <strong>{isLocked ? '🔒 Locked' : tier.state === 'Earned' ? '✓ Earned' : tier.state}</strong>
                </div>
                <p>{tier.requirement}</p>
                <span>{tier.description}</span>
            </div>
            {/*<div className={styles.tierReveal}>*/}
            {/*    <strong>{tier.detail}</strong>*/}
            {/*    <span>Coin Preview</span>*/}
            {/*</div>*/}
        </article>
    );
}

function AchievementProgress({ movie }) {
    const featuredMovie = {
        title: 'The Dark Knight',
        poster: movie?.poster,
        year: '2008',
        ...movie,
    };

    return (
        <section className={styles.section} aria-labelledby="achievement-progress-title">
            <div className={styles.header}>
                <p className={styles.eyebrow}>Movie Mastery</p>
                <h2 id="achievement-progress-title">Earn More Than Ratings</h2>
                <p>Every movie and TV show has its own achievement journey. Answer questions. Improve your score. Master your favorites.</p>
            </div>

            <div className={styles.masteryTracker} aria-label="The Dark Knight movie mastery tracker">
                {defaultTiers.map((tier) => (
                    <div className={styles.trackerStep} key={tier.tier}>
                        <span>{tier.state === 'Earned' ? '✓' : tier.state === 'Locked' ? '🔒' : '○'}</span>
                        <strong>{tier.tier}</strong>
                    </div>
                ))}
            </div>

            <div className={styles.progressStage}>
                <aside className={styles.posterPanel}>
                    <img src={featuredMovie.poster} alt={`${featuredMovie.title} collectible coin artwork`} />
                    <div>
                        <span>Now Mastering</span>
                        <strong>{featuredMovie.title}</strong>
                        <em>{featuredMovie.year}</em>
                    </div>
                </aside>

                <div className={styles.timeline}>
                    {defaultTiers.map((tier, index) => (
                        <div className={styles.timelineItem} key={tier.tier}>
                            <AchievementTier tier={tier} movie={featuredMovie} />
                            {index < defaultTiers.length - 1 && <ProgressConnector />}
                        </div>
                    ))}
                </div>
            </div>

            <p className={styles.emotionalCopy}>Most people stop at Bronze. Only dedicated fans earn Gold. Legendary is reserved for true movie masters.</p>
        </section>
    );
}

export default AchievementProgress;
